import {NavLink} from "react-router-dom";
import { Navbar, Nav, Dropdown } from "react-bootstrap";
import { useAuth } from "../pages/login/AuthProvider";
import "../styles/navbar.scss";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { backend } from './apipath';

export default function AdmNavbar() {

    // const userData = localStorage.getItem('authAdm');
    // let decodeUserData;
    // if(userData) {
    // try{
    //     decodeUserData = JSON.parse(userData);
    // } catch (err){

    // }
    // }
    const { authorized, name, type, logout, setAuth } = useAuth();
    const navigate = useNavigate();

    
    useEffect(() => {
        axios.get(`${backend}login/checkAuth`, { withCredentials: true })
            .then(res => {
                const userType = res.data?.type;
                if (userType === "admin" || userType === "teacher") {
                    setAuth({ ...res.data, authorized: true }); // ✅ 重設狀態（解決畫面卡住老師）
                } else {
                    navigate("/adm/admlogin", { replace: true });
                }
            })
            .catch(() => {
                setAuth({ authorized: false, id: 0, account: "", name: "", type: "" });
                navigate("/adm/admlogin", { replace: true });
            });
    }, []);
    return (
        <>
            <Navbar expand="lg" variant="dark" style={{ backgroundColor: '#152046' }}>
                <div className="container cwd">
                    <NavLink className="navbar-brand logo" to="/adm/admh">
                        <img src="/logo/logo.svg" alt="logo" />
                    </NavLink>
                    <Navbar.Toggle aria-controls="navbarScroll" />
                    <Navbar.Collapse id="navbarScroll">
                    <Nav className="me-auto">
                    {/* admin 專屬功能 */}
                    {type === "admin" && (
                        <>
                        <Dropdown as={Nav.Item}>
                            <Dropdown.Toggle className="nav-link">網站管理</Dropdown.Toggle>
                            <Dropdown.Menu>
                            <Dropdown.Item as={NavLink} to="./admnews">最新消息</Dropdown.Item>
                            <Dropdown.Item as={NavLink} to="./admvideo">影片專區</Dropdown.Item>
                            <Dropdown.Item as={NavLink} to="./admshare">分享專區</Dropdown.Item>
                            <Dropdown.Item as={NavLink} to="./admlog">修改紀錄</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>

                        <Dropdown as={Nav.Item}>
                            <Dropdown.Toggle className="nav-link">人員管理</Dropdown.Toggle>
                            <Dropdown.Menu>
                            <Dropdown.Item as={NavLink} to="./admstaff">員工管理</Dropdown.Item>
                            <Dropdown.Item as={NavLink} to="./admteacher">老師管理</Dropdown.Item>
                            {/* <Dropdown.Item as={NavLink} to="./admmember">學員管理</Dropdown.Item> */}
                            </Dropdown.Menu>
                        </Dropdown>

                        <Dropdown as={Nav.Item}>
                            <Dropdown.Toggle className="nav-link">產品管理</Dropdown.Toggle>
                            <Dropdown.Menu>
                            <Dropdown.Item as={NavLink} to="./admorder">購買管理</Dropdown.Item>
                            <Dropdown.Item as={NavLink} to="./admproduct">方案管理</Dropdown.Item>
                            <Dropdown.Item as={NavLink} to="./admdiscount">優惠管理</Dropdown.Item>
                            {/* <Dropdown.Item as={NavLink} to="./admmou">MOU管理</Dropdown.Item> */}
                            </Dropdown.Menu>
                        </Dropdown>

                        <Dropdown as={Nav.Item}>
                            <Dropdown.Toggle className="nav-link">申請管理</Dropdown.Toggle>
                            <Dropdown.Menu>
                            <Dropdown.Item as={NavLink} to="./admextend">展延管理</Dropdown.Item>
                            <Dropdown.Item as={NavLink} to="./admpoint">點數管理</Dropdown.Item>
                            <Dropdown.Item as={NavLink} to="./admbook">領書管理</Dropdown.Item>
                            <Dropdown.Item as={NavLink} to="./admadd">加購管理</Dropdown.Item>
                            <Dropdown.Item as={NavLink} to="./admeve">評估管理</Dropdown.Item>
                            <Dropdown.Item as={NavLink} to="./admrecommend">推薦管理</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>

                        <Nav.Item>
                            <NavLink className="nav-link" to="./admmemberview">會員總表</NavLink>
                        </Nav.Item>

                        <Nav.Item>
                            <NavLink className="nav-link" to="./admreport">業績總表</NavLink>
                        </Nav.Item>
                        </>
                    )}

                    {/* teacher 與 admin 共用功能 */}
                    <Nav.Item>
                        <NavLink className="nav-link" to="./admqa">Q&A管理</NavLink>
                    </Nav.Item>

                    {/* 使用者資訊與登出按鈕 */}
                    <li className="nav-item navicon">
                        {authorized && (
                        <div className="text-white">
                            <div className="memname">{name}</div>
                            <div className="text-white logouttext" onClick={logout}>
                            登出
                            </div>
                        </div>
                        )}
                    </li>
                    </Nav>

                    </Navbar.Collapse>
                </div>
            </Navbar>       
        </>
    );
}